<template>
    <div class="container">
        <div class="col-md-12 no-padding">
            <div class="col-xs-12 col-md-8 no-padding">
                <div class="row">
                    <div>
                        <div id="productNameHeader" :style="{ '--color' : header.non_repeat.nameColor}"
                             class="title-color productName"
                             v-html="header.non_repeat.productName"></div>
                        <div id="productTitleHeader" :style="{ '--color' : header.non_repeat.titleColor}"
                             class="title-color title-style"
                             v-html="header.non_repeat.title"></div>
                        <div class="row">
                            <div id="descriptionHeader" :style="{ '--color' : header.non_repeat.textColor}"
                                 class="title-color title-style"
                                 v-html="header.non_repeat.text"></div>
                        </div>
                        <div class="row">
                            <div class="logo">
                                <div v-for="(repeatables, index) in header.repeat" :key="'repeatable-' + index">
                                    <template v-if="!featureFlags.show_trust_image">
                                        <template v-if="repeatables['logo_link']">
                                            <a :href="repeatables['logo_link']" target="_blank">
                                                <img
                                                    id="trustBadgeHeader"
                                                    :src="repeatables['logo_url']"
                                                    class="logo-image lazy"
                                                    :alt="repeatables['logo_alt']"
                                                />
                                            </a>
                                        </template>
                                        <template v-else>
                                            <img
                                                id="trustBadgeHeader"
                                                :src="repeatables['logo_url']"
                                                class="logo-image"
                                                :alt="repeatables['logo_alt']"
                                            />
                                        </template>
                                    </template>
                                </div>
                            </div>
                            <template v-if="featureFlags.show_trust_image">
                                <div class="row trust-image">
                                    <div v-for="(trustBadge, index) in trustBadges" :key="'trustbadge-' + index">
                                        <template v-if="trustBadge.trust_link">
                                            <a :href="trustBadge.trust_link" target="_blank">
                                                <img :src="trustBadge.trust_image.url" class="trust-badge" :alt="trustBadge.trust_image.alt">
                                            </a>
                                        </template>
                                        <template v-else>
                                            <img :src="trustBadge.trust_image.url" class="trust-badge" :alt="trustBadge.trust_image.alt">
                                        </template>
                                    </div>
                                    <div v-for="(repeatables, index) in header.repeat" :key="'repeatable-' + index">
                                        <template v-if="repeatables['logo_link']">
                                            <a :href="repeatables['logo_link']" target="_blank">
                                                <img
                                                    id="trustBadgeHeader"
                                                    :src="repeatables['logo_url']"
                                                    class="trust-badge"
                                                    :alt="repeatables['logo_alt']"
                                                />
                                            </a>
                                        </template>
                                        <template v-else>
                                            <img
                                                id="trustBadgeHeader"
                                                :src="repeatables['logo_url']"
                                                class="trust-badge"
                                                :alt="repeatables['logo_alt']"
                                            />
                                        </template>
                                    </div>
                                </div>
                            </template>
                            <div class="sale-image" v-if="generalVoucherImage || header.non_repeat.discount_image">
                                <template v-if="generalVoucherImage">
                                    <img id="discountImageHeader" :src="generalVoucherImage" class="discount-image">
                                </template>
                                <template v-else-if="header.non_repeat.discount_image">
                                    <img id="discountImageHeader" :src="header.non_repeat.discount_image"
                                         class="discount-image">
                                    <div id="discountTextHeader" class="discount-text"
                                         v-html="header.non_repeat.discount_text"></div>
                                </template>
                            </div>
                            <div class="trustpilot" v-if="statusCookies" v-html="widget"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4 no-padding">
                <div class="new-landing-page-configurator">
                    <product-configurator :advantages="advantages"
                                          :campaign="campaign"
                                          :checkout-parameters="checkoutParameters"
                                          :config-contract-type="configContractType"
                                          :config-duration="configDuration"
                                          :default-sales-channel="defaultSalesChannel"
                                          :disable-creditcard="disableCreditcard"
                                          :disable-paypal="disablePaypal"
                                          :disable-sepa="disableSepa"
                                          :document="document"
                                          :eTrack-data="eTrackerData"
                                          :faq-entries="faqEntries"
                                          :faq-headlines="faqHeadline"
                                          :featureFlags="featureFlags"
                                          :further-products="further_products"
                                          :haspa-joker-product="haspaJokerProduct"
                                          :haspa-product="haspaProduct"
                                          :header="header"
                                          :hiw="hiw"
                                          :hover-text="hoverText"
                                          :hs-product="hsProduct"
                                          :initial-values="initialValues"
                                          :insurance-benifits="insuranceBenifits"
                                          :insurance-details="insuranceDetails"
                                          :lang="lang"
                                          :locale="locale"
                                          :media="media"
                                          :min-subscription-durations="minSubscriptionDurations"
                                          :navigation="navigation"
                                          :new-electronic-product="newElectronicProduct"
                                          :og-meta="og_meta"
                                          :policy-attributes="policyAttributes"
                                          :prismic-qualities="qualityData.qualities"
                                          :product="product"
                                          :product-selector="productSelector"
                                          :productId="productId"
                                          :products-with-single-two-years-durations="productsWithSingleTwoYearsDurations"
                                          :quality-data="qualityData"
                                          :related-product-headline="relatedProductsHeadline"
                                          :related-products="relatedProducts"
                                          :sales-channel="salesChannel"
                                          :sales-channel-products-without-single-durations="salesChannelProductsWithoutSingleDurations"
                                          :scope="scope"
                                          :sd-landing-page="sd_landing_page"
                                          :sm-product="smmProduct"
                                          :texts="texts"
                                          :trusted-icons="trustedIcons"
                                          :voucher-general="voucherGeneral"
                                          :product-attribute="productAttribute"
                                          :bundle-coverage="bundleCoverage"
                                          :connect-api-url="connectApiUrl"
                    ></product-configurator>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import ProductConfigurator from "./ProductConfigurator";

export default {
    components: {ProductConfigurator},
    name: "headerSection",
    props: ['header', 'featureFlags', 'document', 'productId', 'product', 'initialValues', 'checkoutParameters', 'insuranceBenifits', 'insuranceDetails',
        'qualityData', 'relatedProductsHeadline', 'relatedProducts', 'hoverText', 'trustedIcons', 'scope', 'advantages', 'hiw', 'faqHeadline',
        'faqEntries', 'og_meta', 'further_products', 'disableSepa', 'disablePaypal', 'disableCreditcard', 'sd_landing_page', 'salesChannel', 'eTrackerData',
        'voucherGeneral', 'policyAttributes', 'media', 'productSelector', 'configDuration', 'configContractType', 'langExtranet', 'lang', 'salesChannelProductsWithoutSingleDurations',
        'newElectronicProduct', 'hsProduct', 'haspaProduct', 'haspaJokerProduct', 'campaign', 'defaultSalesChannel', 'productsWithSingleTwoYearsDurations', 'navigation', 'smmProduct',
        'minSubscriptionDurations', 'locale', 'widget','statusCookies', 'trustBadges','productAttribute','bundleCoverage','connectApiUrl'],
    data: function () {
        return {
            texts: {
                insuranceSum: this.langExtranet.insuranceSum,
                timeUnit: this.langExtranet.timeUnit,
            }
        }
    },
    computed: {
        generalVoucherImage: function () {
            const path = location.pathname;
            for (const category in this.navigation.submenus) {
                for (const submenu of this.navigation.submenus[category]) {
                    for (const subitem of submenu.subitems) {
                        if (subitem.slug === path) {
                            return subitem.voucher;
                        }
                    }
                }
            }
            return undefined;
        }
    }
}
</script>

<style scoped lang="scss">
@import "../../css/variables.scss";
.trustpilot {
    width: 255px;
    margin-top: 30px;
}
.trust-image{
  display: flex;
  @media (max-width:$md-breakpoint-max) {
    display: block;
  }
}
.trust-badge{
  width: auto;
  height: 80px;
  margin-bottom: 10px;
  margin-right: 10px;
}
</style>


